import plugins from '../produto/config/basic-plugins';
import APIResources from '../common/resources';

export default (Vue, ...params) => {
  plugins(Vue, ...params);
  Vue.use(APIResources);
};
